// extracted by mini-css-extract-plugin
export default {"button":"Button_button__EqJ-p","btn__loading":"Button_btn__loading__y-J4y","button__delete":"Button_button__delete__Pk2K8"};